"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const functions_1 = require("./functions");
function default_1({ profileForm, }) {
    var _a;
    const { requiredName, lengthLimitName, noBFSpaceName, noConsonantName } = functions_1.profileErrors;
    const { register, formState: { errors, defaultValues }, } = profileForm;
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h6", { children: t('닉네임') }), (0, jsx_runtime_1.jsx)("input", Object.assign({ type: "text", autoComplete: "off", placeholder: t('닉네임') }, register('name', {
                required: requiredName(),
                validate: {
                    lengthLimit: v => v.length < 9 || lengthLimitName(),
                    noBFSpace: v => v.length === v.trim().length || noBFSpaceName(),
                    noConsonant: v => !/[ㄱ-ㅎㅏ-ㅣ]/g.test(v) || noConsonantName(),
                },
            }))), (0, jsx_runtime_1.jsx)("h5", { children: (_a = errors.name) === null || _a === void 0 ? void 0 : _a.message })] }));
}
exports.default = default_1;
